import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import Fade from '@material-ui/core/Fade';

export default ({loading=false}) => (
<div style={{flexGrow: 1}}>
  <Fade in={loading} 
    style={{transitionDelay: loading ? '800ms':'0ms'}}
    unmountOnExit>
    <LinearProgress color={'primary'}/>
  </Fade>
</div>
);